export const ATTRIBUTES = ['Spice', 'Sour', 'Sweet', 'Bitter', 'Umami', 'Salt', 'Fatty'];

export const SMELL_ATTRIBUTES = [
  'Smoky', 'Herbal', 'Citrusy', 'Fermented',
  'Roasted', 'Fresh', 'SweetAroma', 'Pungent', 'Earthy'
];

export const ALL_ATTRIBUTES = [...ATTRIBUTES, ...SMELL_ATTRIBUTES];

export const exclusionKeyFor = (attr) => `exclude${attr}`;


